import type { SetStateAction } from "react";
import type { Moment } from "moment";
import type { FormInstance } from "antd";
import { IOfferTarifficationFormData } from "../context/types";
import { TariffModelTypes } from "../../../lib/const/tariffModelTypes";
import { TariffPeriodAlignments } from "../../../lib/const/tariffPeriodAlignments";
import type { IOfferParamsFormData } from "../context/types";
import { getRateTypeId } from "./getRateTypeId";
import { getPriceUnitId } from "./getPriceUnitId";

// Изменение зависимых полей при измененении бизнес-модели

interface Props {
  tariffModelTypeId: TariffModelTypes;
  offerParamsForm: FormInstance<IOfferParamsFormData<Moment>>;
  tarifficationForm: FormInstance<IOfferTarifficationFormData<Moment>>;
  setIsPacketTariff: (value: SetStateAction<boolean>) => void;
}

export const onChangeTariffModelId = (props: Props) => {
  const { tariffModelTypeId, offerParamsForm, tarifficationForm, setIsPacketTariff } = props;
  const periodAlignmentId =
    tariffModelTypeId === TariffModelTypes.PACKET ? TariffPeriodAlignments.EVENT : undefined;
  offerParamsForm.setFieldsValue({ periodAlignmentId });
  setIsPacketTariff(tariffModelTypeId === TariffModelTypes.PACKET);
  const { serviceRates } = tarifficationForm.getFieldsValue();
  if (serviceRates) {
    const updatedServiceRates = serviceRates?.map((item) =>
      item.rateModeId
        ? {
            ...item,
            rateTypeId: getRateTypeId(item.rateModeId),
            priceUnitId: getPriceUnitId(
              tariffModelTypeId === TariffModelTypes.PACKET,
              item.rateModeId
            ),
          }
        : item
    );
    tarifficationForm.setFieldsValue({ serviceRates: updatedServiceRates });
  }
};
